import { render } from "./ModalFuzzyMatches.vue?vue&type=template&id=10c16644"
import script from "./ModalFuzzyMatches.vue?vue&type=script&lang=js"
export * from "./ModalFuzzyMatches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__